var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  fillRule: "evenodd",
  d: "M17.5 8.552C17.5 3.829 13.694 0 9 0S.5 3.829.5 8.552c0 4.27 3.112 7.81 7.178 8.448v-5.978H5.505v-2.47h2.173V6.667c0-2.143 1.263-3.331 3.205-3.331.93 0 1.895.18 1.895.18v2.09h-1.065c-1.055 0-1.393.665-1.393 1.342l.002 1.604h2.361l-.377 2.47h-1.984V17c4.066-.639 7.178-4.178 7.178-8.448",
  clipRule: "evenodd"
})));
export default SvgFacebookRounded;